import { chakra, Flex, IconButton, omitThemingProps, useStyleConfig, } from '@chakra-ui/react';
import React from 'react';
import { CloseIcon } from '../icons';
export const Banner = (props) => {
    const styles = useStyleConfig('Banner', props);
    const ownProps = omitThemingProps(props);
    const { children, onClose, ...divProps } = ownProps;
    return (React.createElement(chakra.div, { __css: styles, ...divProps },
        React.createElement(Flex, { flex: "1", justifyContent: "center" }, children),
        onClose && (React.createElement(IconButton, { icon: React.createElement(CloseIcon, { boxSize: "4" }), position: "absolute", right: "1", "aria-label": "Close Banner", variant: "unstyled", color: "inherit", opacity: 0.67, size: "sm", boxSize: "5", onClick: onClose }))));
};
//# sourceMappingURL=Banner.js.map